
import { defineComponent, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['resetted', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            search: null as string | null,
            bin: null as string | null,
        })

        const reset = () => {
            if (props.loading) return

            state.search = null
            state.bin = null

            emit('resetted')
        }

        const search = () => {
            if (props.loading) return

            emit('search', { ...state })
        }

        return {
            state,
            //
            reset,
            search,
        }
    },
})
